exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".follow-btn-draggableContainer-3bQph{z-index:var(--z-index-tips);position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none}.follow-btn-draggableContainer-3bQph>div{pointer-events:auto}", ""]);

// Exports
exports.locals = {
	"draggableContainer": "follow-btn-draggableContainer-3bQph"
};